<div class="search-role-dialog">
  <div mat-dialog-title>
    <h2>Select Role</h2>
  </div>

  <div mat-dialog-content>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Select a role</mat-label>
      <mat-select [formControl]="roleControl" placeholder="Choose a role">
        @for (role of userRoles; track role) {
        <mat-option [value]="role">
          {{ role.profiletype }} (ID: {{ role.profiletypeid }})
        </mat-option>
        }
      </mat-select>
      @if (searchingRoles) {
      <mat-spinner matSuffix diameter="25"></mat-spinner>
      }
    </mat-form-field>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!roleControl.value"
      (click)="confirm()"
    >
      Confirm
    </button>
  </div>
</div>
